import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatApiErrorDetail } from '../contexts/AuthContext';
import { ImageUpload } from '../components/ImageUpload';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CreateRestaurant = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    description_en: '',
    description_ru: '',
    address: '',
    phone: '',
    logo_url: '',
    cover_url: '',
    service_fee_percentage: 0,
    currency: 'AZN',
    currency_symbol: '₼',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData({ ...formData, [name]: type === 'number' ? parseFloat(value) || 0 : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/restaurants`, formData, { withCredentials: true });
      navigate(`/restaurant/${data.id}`);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm p-8">
          <button onClick={() => navigate('/dashboard')} className="text-emerald-600 hover:underline mb-4">
            ← Geri
          </button>
          <h1 className="text-3xl font-bold text-gray-800 mb-6" data-testid="create-restaurant-title">
            Yeni Restoran Əlavə Et
          </h1>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Restoran Adı *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" required data-testid="restaurant-name-input" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Təsvir (AZ)</label>
                <textarea name="description" value={formData.description} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" rows="2" data-testid="restaurant-description-input" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Təsvir (EN)</label>
                <textarea name="description_en" value={formData.description_en} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" rows="2" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Təsvir (RU)</label>
                <textarea name="description_ru" value={formData.description_ru} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" rows="2" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ünvan *</label>
                <input type="text" name="address" value={formData.address} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" required data-testid="restaurant-address-input" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Telefon *</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" required data-testid="restaurant-phone-input" placeholder="+994..." />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <ImageUpload
                value={formData.logo_url}
                onChange={(url) => setFormData({ ...formData, logo_url: url })}
                label="Logo Şəkli"
                testId="restaurant-logo"
              />
              <ImageUpload
                value={formData.cover_url}
                onChange={(url) => setFormData({ ...formData, cover_url: url })}
                label="Kapak Şəkli"
                testId="restaurant-cover"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Servis Haqqı (%)</label>
                <input type="number" step="0.1" min="0" max="100" name="service_fee_percentage" value={formData.service_fee_percentage} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Valyuta Kodu</label>
                <select name="currency" value={formData.currency} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500">
                  <option value="AZN">AZN</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="TRY">TRY</option>
                  <option value="RUB">RUB</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Valyuta Simvolu</label>
                <input type="text" name="currency_symbol" value={formData.currency_symbol} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500" maxLength="3" />
              </div>
            </div>

            <button type="submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed" data-testid="create-restaurant-submit">
              {loading ? 'Əlavə edilir...' : 'Restoran Əlavə Et'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
